/**
 * Image Generation API Client
 * 
 * يتعامل مع API لتوليد الصور من HTML
 */

export const IMAGE_API_URL = process.env.REACT_APP_IMAGE_API_URL || 'https://api-render.audome.io/api/replicate-generate';

interface Font {
  name: string;
  url: string;
}

interface GenerateImageRequest {
  html: string;
  width: number;
  height: number;
  fonts?: Font[];
  quality?: number;
}

interface GenerateImageResponse {
  success: boolean;
  image?: string; // data URL
  error?: string;
  metadata?: {
    width: number;
    height: number;
    generationTime: number;
    timestamp: string;
  };
}

/**
 * يولد صورة من HTML باستخدام السيرفر
 */
export async function generateImage(
  request: GenerateImageRequest
): Promise<GenerateImageResponse> {
  try {
    if (!IMAGE_API_URL) {
      throw new Error('IMAGE_API_URL غير معرّف. يرجى تحديد API endpoint.');
    }
    
    console.log(`🚀 إرسال طلب توليد صورة...`);
    console.log(`📏 الأبعاد: ${request.width}x${request.height}px`);
    console.log(`🔤 الخطوط المخصصة: ${request.fonts?.length || 0} خط`);
    
    if (request.fonts && request.fonts.length > 0) {
      console.log('📝 تفاصيل الخطوط:');
      request.fonts.forEach((font, index) => {
        console.log(`   ${index + 1}. ${font.name} - ${font.url}`);
      });
    }
    
    const requestBody = {
      html: request.html,
      width: request.width,
      height: request.height,
      fonts: request.fonts || [],
      quality: request.quality || 100
    };
    
    console.log('📤 Request body size:', JSON.stringify(requestBody).length, 'bytes');
    console.log('📤 Fonts in request:', requestBody.fonts.length);
    
    const response = await fetch(IMAGE_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    const result: any = await response.json();
    
    console.log('📦 API Response:', result);
    
    // تحويل الرد إلى الصيغة المطلوبة
    let imageData = null;
    
    // دعم صيغ مختلفة من الـ API
    if (result.image) {
      imageData = result.image;
    } else if (result.image_url || result.output) {
      const url = result.image_url || result.output;
      console.log(`📥 تحميل الصورة من: ${url.substring(0, 80)}...`);
      
      const imgResp = await fetch(url);
      const blob = await imgResp.blob();
      
      imageData = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
      
      console.log(`✅ تم تحميل الصورة (${(blob.size / 1024).toFixed(0)} KB)`);
    }
    
    if (!imageData) {
      throw new Error('لا توجد صورة في الرد');
    }
    
    return {
      success: true,
      image: imageData,
      metadata: result.metadata || {}
    };

  } catch (error: any) {
    console.error('❌ خطأ في توليد الصورة:', error);
    
    return {
      success: false,
      error: error.message || 'حدث خطأ غير متوقع'
    };
  }
}


/**
 * يحول الـ iframe document إلى HTML string كامل
 */
export function serializeDocument(doc: Document): string {
  // احفظ الـ HTML كاملاً
  return `<!DOCTYPE html>\n${doc.documentElement.outerHTML}`;
}

